
import React, { useState, useEffect } from "react";
import { GetAllWeeklyHolidays, UpdateWeeklyHoliday } from "adminApi/LeaveApi/WeeklyHolidayApi";
import useFetchAllData from "Hooks/useFetchAllData";
import useFormSubmit from "Hooks/useFormSubmit";
import Spinner from "Common/Globle/Spinner";

const ManageWeekHoliday = ({ onSuccess }) => {
    const { data: holidays, loading, refetch } = useFetchAllData(GetAllWeeklyHolidays);
    const [selectedDays, setSelectedDays] = useState({});

    // Initialize/Sync local state when holidays are fetched
    useEffect(() => {
        if (holidays && Array.isArray(holidays)) {
            const initialState = {};
            holidays.forEach(h => {
                initialState[h.holiday_id] = !!h.is_holiday;
            });
            setSelectedDays(initialState);
        }
    }, [holidays]);

    // Handle checkbox change
    const handleCheckboxChange = (id) => {
        setSelectedDays(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    // Standard useFormSubmit hook
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const updates = holidays.filter(h => !!h.is_holiday !== !!formValues[h.holiday_id]);

            if (updates.length === 0) {
                return { data: { success: false, error: "No changes to update" } };
            }

            // Perform updates in parallel
            const results = await Promise.all(
                updates.map(h => UpdateWeeklyHoliday(h.holiday_id, { is_holiday: formValues[h.holiday_id] ? 1 : 0 }))
            );

            const allSuccess = results.every(res => res?.data?.success);
            return {
                data: {
                    success: allSuccess,
                    data: { message: "Weekly holidays updated successfully" }
                }
            };
        },
        () => ({}),
        () => {
            if (onSuccess) onSuccess();
            refetch();
        },
        "Weekly holidays updated successfully"
    );

    // Check for changes to disable/enable update button
    const hasChanges = holidays?.some(h => !!h.is_holiday !== !!selectedDays[h.holiday_id]);

    if (loading) return <div className="p-3">Loading days...</div>;

    return (
        <div className="weekly-leave-container">
            {(loading || loadingSubmit) && <Spinner isSpinner={true} />}

            <div className="row align-items-center g-3">
                <div className="col-12">
                    <span className="form-label text-muted">Weekly Leave Day <span className="text-danger">*</span></span>
                </div>

                <div className="col-12">
                    <div className="d-flex flex-wrap gap-3">
                        {holidays.map((h) => (
                            <div key={h.holiday_id} className="form-check custom-checkbox-item user-select-none">
                                <input
                                    className="form-check-input pointer"
                                    type="checkbox"
                                    id={`day-${h.holiday_id}`}
                                    checked={!!selectedDays[h.holiday_id]}
                                    onChange={() => handleCheckboxChange(h.holiday_id)}
                                />
                                <label className="form-check-label pointer ms-1 fw-medium" htmlFor={`day-${h.holiday_id}`}>
                                    {h.day_name}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="col-12 d-flex justify-content-end mt-4">
                    <button
                        className="btn btn-primary"
                        onClick={(e) => handleSubmit(e, selectedDays)}
                        disabled={loadingSubmit || !hasChanges}
                    >
                        {loadingSubmit ? "Updating..." : "Update"}
                    </button>
                </div>
            </div>
        </div>
    );

};

export default ManageWeekHoliday;
